// istanbul ignore file
export interface UrlFilterParamGroupNames {
  complexities: string;
  categories: string;
  texts: string;
}

export const urlFilterParamGroupNames: UrlFilterParamGroupNames = {
  complexities: 'complexity',
  categories: 'category',
  texts: 'text',
};
